import React from 'react'
import {connect} from 'react-redux'

import showModal from '../shared/data/actions/show_modal'

class ConversationMenuReportItem extends React.Component {
  constructor (props) {
    super(props)

    this.showReportModal = this.showReportModal.bind(this)
  }

  showReportModal (e) {
    e.stopPropagation()
    this.props.showModal({type: 'report', props: {reportee: this.props.reportee}})

    this.props.onReportClicked(e)
  }

  render () {
    return (
      <div className='sliding-menu-item report-user' onClick={this.showReportModal}>
        <i className='menu-item-icon rc-icon-report'></i>
        Report user
      </div>
    )
  }
}

ConversationMenuReportItem.defaultProps = {
  onReportClicked: () => {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const ConversationMenuReportItemContainer = connect(
  null, mapDispatchToProps
)(ConversationMenuReportItem)

export default ConversationMenuReportItemContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_menu_report_item.js
 **/